export interface ParsedTweddleDomain {
  app: string
  mode: string
  clientCode: string
  env: string | null // null = production (.io)
}

const VALID_MODES = ['draft', 'live'] as const

/**
 * Parses a hostname and returns structured domain segments when it matches
 * the v3 branded URL grammar:
 *   Production:     [client].[mode].explorer.gd.tweddle.io           (6 parts)
 *   Non-production: [client].[mode].explorer.[env].gd.tweddle.tech   (7 parts)
 *
 * Returns null for all legacy URLs, v1 branded URLs, v2 branded URLs,
 * localhost, and any other hostname.
 */
export function parseTweddleDomain(
  hostname: string
): ParsedTweddleDomain | null {
  const parts = hostname.split('.')

  // v3 production: [client].[mode].explorer.gd.tweddle.io (6 parts)
  if (hostname.endsWith('.tweddle.io') && parts.length === 6) {
    const [clientCode, mode, app] = parts
    if (
      app === 'explorer' &&
      parts[3] === 'gd' &&
      (VALID_MODES as readonly string[]).includes(mode)
    ) {
      return { app, mode, clientCode, env: null }
    }
  }

  // v3 non-production: [client].[mode].explorer.[env].gd.tweddle.tech (7 parts)
  if (hostname.endsWith('.tweddle.tech') && parts.length === 7) {
    const [clientCode, mode, app, env] = parts
    if (
      app === 'explorer' &&
      parts[4] === 'gd' &&
      (VALID_MODES as readonly string[]).includes(mode)
    ) {
      return { app, mode, clientCode, env }
    }
  }

  return null
}
